import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { problems } from '../../data/content';
export function Problems() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-129" data-mp="1czwrungcist9">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-130" data-mp="1d17v8m5vpyju">
        <SectionTag icon="😩" data-id="element-131" data-mp="1hzj5gy036b2l">El problema</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-132" data-mp="1hy7zcrj64r8b">
          ¿Te pasa esto cada semana?
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-4 px-4 sm:grid-cols-2 sm:px-6" data-id="element-133" data-mp="pb3r8dos3wsb">
        {problems.map((problem, i) => <m.div key={problem.title} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.08
      }} className="flex flex-col rounded-2xl border border-navy/10 bg-cream p-6" data-id="element-134" data-mp="u7c0xbk7ixs3" data-mpi={i}>
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy/10 text-2xl" data-id="element-135" data-mp="67s5lf38v0bt">
              <span aria-hidden="true" data-id="element-136" data-mp="17w0tdmq34v7">{problem.emoji}</span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-semibold leading-snug text-navy" data-id="element-137" data-mp="3smjyf83zpsvl">{problem.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-138" data-mp="3noa1ot2mak7v">{problem.text}</p>
          </m.div>)}
      </div>
    </section>;
}